import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/results";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/results")(withAlternates(routeOptions, "/results"));
